import { defineComponent as v, computed as l, createElementBlock as u, openBlock as o, normalizeClass as z, renderSlot as g, createCommentVNode as i, createBlock as c, toDisplayString as p, unref as m, resolveDynamicComponent as w, toRaw as k } from "vue";
import { sizeNameToSize as x } from "@ds/components/Icon";
import { RevIllustration as C } from "@ds/components/Illustration";
import { tw as a } from "../../utils/tailwind.js";
const S = ["aria-label"], j = { key: 0 }, I = /* @__PURE__ */ v({
  name: "RevAvatar",
  __name: "Avatar",
  props: {
    size: {},
    label: {},
    thumbnail: { type: [String, Object, Function] }
  },
  setup(e) {
    const t = e, d = l(() => !t.thumbnail), b = l(() => typeof t.thumbnail == "string"), h = l(
      () => typeof t.thumbnail == "object" || typeof t.thumbnail == "function"
    ), f = l(() => t.label.charAt(0)), s = l(
      () => ({
        small: 20,
        medium: 40,
        large: 80
      })[t.size]
    ), y = l(() => {
      const n = a`bg-static-default-mid text-static-default-hi rounded-full flex items-center justify-center uppercase leading-none`, r = {
        small: a`body-2-bold size-20`,
        medium: a`font-weight-body-1-bold font-body-1-bold style-body-1-bold size-40 text-[1.25rem]`,
        large: a`font-weight-body-1-bold font-body-1-bold style-body-1-bold size-80 text-[2.75rem]`
      };
      return [n, r[t.size]];
    });
    return (n, r) => (o(), u("div", {
      "aria-label": e.label,
      class: z(y.value)
    }, [
      g(n.$slots, "default", {}, () => [
        d.value ? (o(), u("span", j, p(f.value), 1)) : i("", !0),
        b.value ? (o(), c(m(C), {
          key: 1,
          alt: e.label,
          class: "rounded-full",
          height: s.value,
          src: e.thumbnail,
          title: e.label,
          width: s.value
        }, null, 8, ["alt", "height", "src", "title", "width"])) : i("", !0),
        h.value ? (o(), c(w(k(e.thumbnail)), {
          key: 2,
          size: m(x)[e.size]
        }, null, 8, ["size"])) : i("", !0)
      ])
    ], 10, S));
  }
});
export {
  I as default
};
